import {
  RouteObject
} from "react-router-dom";
import App from "../../App";
import Error from "../../view/error/error";

export const BaseRouter: RouteObject[] = [
  {
    element: <App />,
    errorElement: <Error />,
  },
];

